// Mirrors the API's answers for "Contacts in the old webshop"
// (API flag MissingNavContactsEnabled - both routes answer 404 while it is
// off; FE flag missingNavContactsEnabled). GET
// organizations/{orgId}/missing-nav-contacts: the contacts of the org AND its
// direct children that KitMaker mirrors from NAV (dbo.OrganizationContacts,
// written at the hourly org sync) and that have no Users row with the same
// e-mail (case-insensitive, trimmed). `source` names where the list came
// from - "mirror" today; phase 2 (NAV's contactApi, after the licence fix)
// adds "nav" without changing the shape. The normaliser in
// data/models/mappers/mapMissingNavContacts.ts makes every field present.

export interface MissingNavContactDto {
  /** The mirror row's own id (OrganizationContacts.Id) - what the invite sends. */
  contactId: number;
  /** NAV's contact number (OrganizationContacts.Number) - shown, never sent. */
  contactNo: string;
  name: string;
  /** Blank = the contact has no e-mail in NAV and cannot be created. */
  email: string;
  phone: string;
  isMain: boolean;
  orgId: number;
  orgName: string;
  /** The organisation's NAV customer number (Organizations.NavNumber). */
  orgNavNumber: string;
  orgCvr: string;
  /** false = a direct child (branch) of the route's organisation. */
  isOwnOrg: boolean;
}

export interface MissingNavContactsDto {
  source: string;
  organizationId: number;
  contacts: MissingNavContactDto[];
  /** Contacts the API counted but left out for having no e-mail (0 when it lists them greyed instead). */
  withoutEmail: number;
  /** true = the API capped the list (MaxListRows). */
  truncated: boolean;
}

/** The API's per-row statuses of POST .../missing-nav-contacts/invite. */
export const INVITE_STATUS = {
  created: "created",
  skippedExists: "skipped-exists",
  invalidEmail: "invalid-email",
  excludedDomain: "excluded-domain",
  notFound: "not-found",
  failed: "failed",
} as const;

export interface InviteMissingNavContactItemDto {
  contactId: number;
  contactNo: string;
  /** One of INVITE_STATUS (a plain string: an unknown newer value is shown as failed). */
  status: string;
  /** The created Users row; null unless status is created. */
  userId: number | null;
  /** created only: whether the welcome mail went out (null = not asked for / not said). */
  mailSent: boolean | null;
  /**
   * The API's short MACHINE code of a skipped / failed row
   * (MissingNavContactsPolicy: blankEmail, invalidEmail, userExists,
   * duplicateInBatch, loginAccountExists, invalidPhone, loginAccount,
   * userRow, inProgress, notInScope, ...) - for support and logs, never shown.
   */
  reason: string | null;
  /** The API's user-facing text of that row (the users/create texts) - shown as it is on a failed row. */
  message: string | null;
}

export interface InviteMissingNavContactsResultDto {
  results: InviteMissingNavContactItemDto[];
  created: number;
  skipped: number;
  failed: number;
  mailNotSent: number;
}
